module.exports = __webpack_public_path__ + "img/ccb.8f0959f7.png";